"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handle_fetch_json_response = exports.get_object_entries = exports.get_url_search_params = exports.get_first_element_by_class_or_null = exports.get_first_element_by_class_or_fail = exports.get_element_by_id_or_fail = exports.get_element_by_id_or_null = exports.get_parent_element_by_class = exports.get_parent_element_by_condition = void 0;
var fromEntries = require('object.fromentries');
var entries = require('object.entries');
function get_parent_element_by_condition(element, condition) {
    var parent = element;
    while (parent) {
        if (parent === document.body)
            return null;
        if (condition(parent))
            return parent;
        parent = parent.parentElement;
    }
    return null;
}
exports.get_parent_element_by_condition = get_parent_element_by_condition;
function get_parent_element_by_class(element, classname) {
    return get_parent_element_by_condition(element, function (element) { return element.classList.contains(classname); });
}
exports.get_parent_element_by_class = get_parent_element_by_class;
function get_element_by_id_or_null(id, class_type) {
    if (class_type === void 0) { class_type = HTMLElement; }
    var element = document.getElementById(id);
    if (!class_type || !(element instanceof class_type))
        return null;
    return element;
}
exports.get_element_by_id_or_null = get_element_by_id_or_null;
function get_element_by_id_or_fail(id, type) {
    if (type === void 0) { type = HTMLElement; }
    var element = get_element_by_id_or_null(id, type);
    if (element === null)
        throw new Error('Could not find element with ID ' + id);
    return element;
}
exports.get_element_by_id_or_fail = get_element_by_id_or_fail;
function get_first_element_by_class_or_fail(root, classname, class_type) {
    if (class_type === void 0) { class_type = HTMLElement; }
    var element = get_first_element_by_class_or_null(root, classname, class_type);
    if (element === null)
        throw new Error('Could not find element with class ' + classname);
    return element;
}
exports.get_first_element_by_class_or_fail = get_first_element_by_class_or_fail;
function get_first_element_by_class_or_null(root, classname, class_type) {
    if (class_type === void 0) { class_type = HTMLElement; }
    var element = root.getElementsByClassName(classname).item(0);
    if (!class_type || !(element instanceof class_type))
        return null;
    return element;
}
exports.get_first_element_by_class_or_null = get_first_element_by_class_or_null;
function get_url_search_params() {
    return fromEntries(get_object_entries((new URL(window.location.href)).searchParams));
}
exports.get_url_search_params = get_url_search_params;
function get_object_entries(object) {
    var keys = object.keys();
    var buffer = new Array(0);
    var key_it = keys.next();
    var i = 0;
    while (!key_it.done) {
        buffer[i] = [key_it.value, object.get(key_it.value)];
        key_it = keys.next();
    }
    return buffer;
}
exports.get_object_entries = get_object_entries;
function handle_fetch_json_response(response) {
    if (!response.ok)
        return Promise.reject('Server Error');
    return response.json().then(function (response) {
        if (response.success !== true)
            Promise.reject();
        return response.content;
    });
}
exports.handle_fetch_json_response = handle_fetch_json_response;
